var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import { Input, useId, useValue, useFocus, useTouched, useAutofill, createClassName, statusIcons, flatObj } from '../common';
import cn from 'classnames';

var TGInput = function TGInput(_ref) {
  var icon = _ref.icon,
      props = _objectWithoutProperties(_ref, ['icon']);

  var input = {
    id: props.id || useId(),
    value: useValue(props.value),
    focus: useFocus(),
    touched: useTouched(),
    autofill: useAutofill()
  };

  var _onChange = function _onChange(e) {
    return props.onChange && props.onChange(e, e.target.value);
  };

  var _onBlur = function _onBlur(e) {
    return props.onBlur && props.onBlur(e, e.target.value);
  };

  var className = createClassName('tg-input', {
    hasValue: input.value.hasValue,
    hasLabel: Boolean(props.label),
    hasFocus: input.focus.hasFocus,
    hasTouched: input.touched.hasTouched,
    hasAutofill: input.autofill.hasAutofill,
    disabled: props.disabled,
    status: props.status
  });

  return React.createElement(
    'div',
    { className: cn(props.className, className) },
    React.createElement(Input, _extends({}, props, flatObj(input), {
      onChange: function onChange(e) {
        if (typeof props.transform === 'function') {
          e.target.value = props.transform(e.target.value);
        }
        input.value.onChange(e.target.value);
        _onChange(e);
      },
      onFocus: function onFocus() {
        input.focus.onFocus();
        input.touched.onFocus();
      },
      onBlur: function onBlur(e) {
        input.focus.onBlur();
        _onBlur(e);
      },
      leadingLane: [icon].filter(function (i) {
        return i;
      }),
      trailingLane: [statusIcons[props.status]].filter(function (i) {
        return i;
      })
    })),
    React.createElement(
      'div',
      { className: 'tg-input__status-text' },
      props.statusText
    )
  );
};

export default TGInput;